const canvas = document.getElementById('snowfall-canvas');
const ctx = canvas.getContext('2d');

// Set canvas size
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

// Get snowflake count from settings (passed from Liquid)
const snowflakeCount = window.snowflakeCount || 400;
const snowflakes = [];
const snowflakeSymbols = ['❅', '•','❄'];

// Snowflake constructor
function Snowflake() {
  this.x = Math.random() * canvas.width;
  this.y = Math.random() * canvas.height;
  this.size = Math.random() * 8 + 8;
  this.speedY = Math.random() * 0.5 + 0.3;
  this.speedX = Math.random() * 0.5 - 0.25;
  this.opacity = Math.random() * 0.5 + 0.3;
  this.symbol = snowflakeSymbols[Math.floor(Math.random() * snowflakeSymbols.length)];
}

// Update snowflake position
Snowflake.prototype.update = function() {
  this.y += this.speedY;
  this.x += this.speedX;

  // Reset snowflake when it goes off screen
  if (this.y > canvas.height) {
    this.y = -10;
    this.x = Math.random() * canvas.width;
  }

  // Wrap horizontally
  if (this.x > canvas.width) {
    this.x = 0;
  } else if (this.x < 0) {
    this.x = canvas.width;
  }
};

// Draw snowflake
Snowflake.prototype.draw = function() {
  ctx.font = `${this.size}px Arial`;
  ctx.fillStyle = `rgba(255, 255, 255, ${this.opacity})`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(this.symbol, this.x, this.y);
};

// Create snowflakes based on count from settings
for (let i = 0; i < snowflakeCount; i++) {
  snowflakes.push(new Snowflake());
}

// Animation loop
function animate() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  
  snowflakes.forEach(snowflake => {
    snowflake.update();
    snowflake.draw();
  });
  
  requestAnimationFrame(animate);
}

// Start animation
animate();

// Handle window resize
window.addEventListener('resize', () => {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
});